import React from "react";
import styled from "styled-components";
import { height, width } from "styled-system";

const StyledSvg = styled.svg`
  ${height}
  ${width}
  --icon-fill: #1998d5;
`;

const Neighbors = ({
  height = "24",
  viewBox = "0 0 24 24",
  width = "24",
  ...props
}) => (
  <StyledSvg
    fill={"none"}
    height={height}
    viewBox={viewBox}
    width={width}
    {...props}
  >
    <mask
      id={"neighbors-mask0"}
      style={{ maskType: "alpha" }}
      maskUnits={"userSpaceOnUse"}
      x={"0"}
      y={"0"}
      width={"24"}
      height={"24"}
    >
      <path
        fillRule={"evenodd"}
        clipRule={"evenodd"}
        d={
          "M11.9999 0C5.37248 6.60527e-05 -4.40348e-05 5.37268 2.70693e-10 12.0001C4.40353e-05 18.6275 5.37264 24 12 24C18.6274 24 24 18.6274 24 12C23.9925 5.37565 18.6242 0.0074478 11.9999 0ZM11.8602 2.66778C13.1102 2.6483 14.351 2.88463 15.5059 3.36218C17.7675 4.29807 19.5795 6.06952 20.5637 8.30677C21.0652 9.4485 21.3269 10.6807 21.3328 11.9272C21.3532 14.3856 20.393 16.751 18.6639 18.5021C18.6236 18.5447 18.5584 18.5522 18.5095 18.5199C18.4596 18.4889 18.4386 18.4271 18.4591 18.3722C18.6173 17.968 18.7446 17.5526 18.84 17.1293C19.0161 16.2575 18.9675 15.8641 18.9415 15.6534L18.9375 15.6212C18.83 14.7016 17.5408 14.2613 16.2657 13.9567C16.3349 14.7291 16.326 15.5064 16.2391 16.2769C16.1062 17.2982 15.8112 18.2918 15.3653 19.2206C15.3372 19.2744 15.2742 19.2999 15.2164 19.2809C15.1587 19.2618 15.1233 19.2039 15.1329 19.1439C15.272 18.2424 15.5431 14.7173 15.2102 13.7013C14.8412 12.5756 13.4284 12.4367 12.0104 12.4356C10.5932 12.4364 9.20531 12.5841 8.81141 13.7013C8.40242 14.8615 8.77713 18.447 8.89217 19.19C8.90229 19.2499 8.86682 19.3081 8.80888 19.3267C8.79585 19.3311 8.78219 19.3333 8.76844 19.3333C8.72275 19.3334 8.68085 19.308 8.65979 19.2676C8.35546 18.7006 7.95613 17.5345 7.76129 16.2767C7.65923 15.5071 7.65032 14.7281 7.73474 13.9565C7.18595 14.0872 6.5144 14.2698 5.99749 14.5364C5.41902 14.8345 5.11336 15.1892 5.0629 15.6207C5.05921 15.6529 5.05307 15.684 5.04635 15.718C5.01086 15.8976 4.9588 16.161 5.16044 17.1288C5.25731 17.5525 5.38488 17.9687 5.54215 18.374C5.5627 18.4289 5.54165 18.4907 5.49181 18.5217C5.44289 18.5539 5.3779 18.5464 5.33765 18.5039C2.72311 15.8444 1.94819 11.8858 3.36753 8.4398C4.78687 4.99381 8.12736 2.72346 11.8602 2.66778ZM5.80329 11.6889C6.05396 12.293 6.64457 12.6868 7.2997 12.6868C8.19366 12.6858 8.91817 11.9629 8.91936 11.0708C8.91951 10.417 8.52498 9.82748 7.91977 9.57718C7.31455 9.32688 6.61785 9.46508 6.15455 9.92734C5.69126 10.3896 5.55262 11.0849 5.80329 11.6889ZM11.9995 11.1858C10.9194 11.1858 10.0439 10.312 10.0439 9.23417C10.0439 8.15629 10.9194 7.2825 11.9995 7.2825C13.0795 7.2825 13.9551 8.15629 13.9551 9.23417C13.9541 10.3117 13.0791 11.185 11.9994 11.1861L11.9995 11.1858ZM15.0802 11.0704C15.0802 11.9631 15.8054 12.6868 16.6999 12.6868C17.594 12.6858 18.3186 11.9627 18.3196 11.0704C18.3196 10.1777 17.5944 9.45405 16.6999 9.45405C15.8054 9.45405 15.0802 10.1777 15.0802 11.0704ZM12.0003 22.804C17.9671 22.804 22.8042 17.9669 22.8042 12C22.7974 6.03587 17.9642 1.20271 12.0001 1.19599C6.03323 1.19605 1.19617 6.0332 1.19621 12.0001C1.19626 17.9669 6.03339 22.804 12.0003 22.804Z"
        }
        fill={"var(--icon-fill)"}
      />
    </mask>
    <g mask={"url(#neighbors-mask0)"}>
      <rect
        x={"-2.39966"}
        y={"-2.40039"}
        width={"28.8"}
        height={"28.8"}
        fill={"var(--icon-fill)"}
      />
    </g>
  </StyledSvg>
);

export default Neighbors;
